'use strict';

angular.module('buyers')
.directive('propertyDetail', function() {
    return {
        templateUrl : "partials/property-detail.html",
        restrict: 'E', // attribute
        scope: {
            'back': '&onBack',
            'addToWatchlist': '&onAddToWatchlist',
            'removeFromWatchlist': '&onRemoveFromWatchlist', 
            'property':'='
        }
    };
});